import { Injectable } from '@angular/core';
import { AbstractListViewService, ListViewData } from '@y42/core/list-view';
import { ExportListViewData, ExportQuery } from '@y42/data-export';
import { map, Observable } from 'rxjs';

type OrchestrationExportSelectorListViewData = ListViewData<ExportListViewData>;

@Injectable()
export class OrchestrationExportSelectorService extends AbstractListViewService<OrchestrationExportSelectorListViewData> {
  constructor(private readonly exportQuery: ExportQuery) {
    super();
  }

  readonly data$: Observable<ExportListViewData[]> = this.exportQuery.listItems$.pipe(
    map((items) => items.filter((item) => item.hasReadPermission)),
    map(
      (listItems) => listItems,
      // .filter((listItem) => (listItem.triggers?.length || 0) > 0)
    ),
  );

  readonly loading$: Observable<boolean> = this.exportQuery.loading$;
}
